import { render, staticRenderFns } from "./WaitlistModal.vue?vue&type=template&id=736d9bd9&scoped=true&"
import script from "./WaitlistModal.vue?vue&type=script&lang=js&"
export * from "./WaitlistModal.vue?vue&type=script&lang=js&"
import style0 from "./WaitlistModal.vue?vue&type=style&index=0&id=736d9bd9&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d9bd9",
  null
  
)

export default component.exports